import React, { FC, RefObject, useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import cn from 'classnames';

import { useOnClickOutside } from 'client/hooks';
import { getPosition } from 'utils/waiterOnClickPopup-position';
import { RaiseHandMessage } from 'client/redux/pubnub/types';

import ConnectionControls from '../../ConnectionControls';

import css from './WaiterOnClickPopup.module.scss';

type Props = {
  onClose: () => void;
  isAllowedToSpeak?: boolean;
  className?: string;
  listenerData: RaiseHandMessage;
  itemRef?: RefObject<HTMLDivElement> | undefined;
};

const WaiterOnClickPopup: FC<Props> = ({
  onClose,
  listenerData,
  isAllowedToSpeak = false,
  className = '',
  itemRef,
}) => {
  const containerRef = useRef(null);
  const portalDiv = document.getElementById('portal') as HTMLElement;
  const [waiterPopupPosition, setWaiterPopupPosition] = useState({
    top: -10000,
    left: 0,
  });

  useOnClickOutside(containerRef, onClose);

  useEffect(() => {
    if (itemRef?.current) {
      const itemPosition = itemRef.current.getBoundingClientRect();

      setWaiterPopupPosition(getPosition(itemPosition));
    }
  }, [itemRef]);

  const onControlActionSelect = React.useCallback(() => {
    onClose();
  }, [onClose]);

  if (isAllowedToSpeak) {
    return (
      <div className={cn(css.container, className, isAllowedToSpeak && css.secondView)} ref={containerRef}>
        <ConnectionControls
          onSelectAction={onControlActionSelect}
          isAllowedToSpeak={isAllowedToSpeak}
          listener={listenerData}
          className={css.controls}
        />
      </div>
    );
  }

  return ReactDOM.createPortal(
    <div
      className={cn(css.container, className, isAllowedToSpeak && css.secondView)}
      ref={containerRef}
      style={waiterPopupPosition}
    >
      <ConnectionControls
        onSelectAction={onControlActionSelect}
        isAllowedToSpeak={isAllowedToSpeak}
        listener={listenerData}
        className={css.controls}
      />
    </div>,
    portalDiv,
  );
};

export default WaiterOnClickPopup;
